import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sort: '',
  filter: 'all',
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    sorted: (state, action) => {
      state.sort = action.payload;
    },
    filtered: (state, action) => {
      state.filter = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { sorted, filtered } = filterSlice.actions;
